<div [@inOutAnimation] *ngIf="tpcService.showCookiesConsent" class="cookie-policy-banner">
    <div class="text-center mobile-sm-font">
        <span>{{ 'COOKIES.T1' | translate }}</span>
        <br />
    </div>
    <div class="float-right">
        <button mat-flat-button color="accent" (click)="accept()">{{ 'SHARED.ACCEPT' | translate }}</button>
    </div>
</div>